export default __webpack_public_path__ + "static/media/blog3.c0e0e0cc.jpg";